import {InputDate} from '@/components/commons/input-date/InputDate'
import dayjs from 'dayjs'
import {MedicalReportFieldsSchema} from '@/features/medical-reports/formSchemas'
import {useTranslation} from '@/translations/i18n'
import {useController, useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const MedicalReportEndDateFieldSchema = MedicalReportFieldsSchema.pick({
    endDate: true,
    project: true
})
type MedicalReportEndDateFieldSchema = z.infer<typeof MedicalReportEndDateFieldSchema>

export const MedicalReportEndDateField = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<MedicalReportEndDateFieldSchema>()
    const {field, fieldState} = useController({
        control,
        name: 'endDate'
    })

    const project = useWatch({control, name: 'project'})

    return (
        <InputDate
            label={t('medical_records:end_date_pri')}
            value={field.value ?? undefined}
            errorMessage={fieldState.error?.message}
            onChange={field.onChange}
            placeholder="GG/MM/AAAA"
            disableBeforeDate={project?.startDate ? dayjs(project.startDate).toDate() : undefined}
            disableAfterDate={project?.expirationDate ? dayjs(project.expirationDate).toDate() : undefined}
        />
    )
}
